import classNames from "classnames";
import { FieldMessage, fieldDescribedBy, helpTextId } from "./FieldValue";
import { CheckboxFieldProps } from "./CheckboxField.types";

export function CheckboxField({
  label,
  name,
  value,
  onChange,
  disabled,
  error,
  className = "",
  helpText,
}: CheckboxFieldProps) {
  return (
    <div
      className={classNames("field-value form-check", className)}
    >
      <input
        id={name}
        name={name}
        type="checkbox"
        className={classNames("form-check-input", { "is-invalid": error })}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        checked={!!value}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={name}>
        {label}
      </label>
      {helpText && (
        <p
          id={helpTextId(name)}
          className="form-text small text-body-secondary mb-0"
        >
          {helpText}
        </p>
      )}
      <FieldMessage name={name} error={error} />
    </div>
  );
}
